export default __webpack_public_path__ + "static/media/249.1ff5a8d5.gif";